import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=b38bbe70&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&id=b38bbe70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38bbe70",
  null
  
)

export default component.exports